import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';
import { TrainCardType, TrainFlashcard } from '../../../deck-train.models';

@Component({
  selector: 'app-text-simple-train-back',
  imports: [],
  templateUrl: './text-simple-train-back.html',
  styleUrl: './text-simple-train-back.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextSimpleTrainBack {
  private readonly deckTranslations =
    inject(UiTranslationService).namespace('deck');

  readonly card = input.required<TrainFlashcard>();
  readonly isBackVisible = input.required<boolean>();
  readonly hasFrontMedia = input(false);
  readonly isVideoFront = input(false);
  readonly isVideoFrontResolved = computed(
    () =>
      this.isVideoFront() || this.card().cardType === TrainCardType.VideoOnly,
  );

  readonly t = this.deckTranslations.t;
}
